import { QueryClientProvider } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { BrowserRouter } from 'react-router-dom'

import { useAuthStore } from './auth/auth-store'
import { notifySessionEnded } from './auth/token-storage'
import { ErrorBoundary } from './components/error-boundary'
import { createQueryClient } from './lib/query-client'
import { AppRoutes } from './routes/app-routes'
import { initTheme } from './theme/theme-store'

const REFRESH_TOKEN_STORAGE_KEY = 'fleetcore.rt'

export function App() {
  const [queryClient] = useState(createQueryClient)

  useEffect(() => initTheme(), [])

  useEffect(() => {
    void useAuthStore.getState().bootstrap()
  }, [])

  useEffect(() => {
    // Signing out in one tab has to sign out the others. Workshop and dispatch
    // machines are shared, and a forgotten second tab is a live session.
    const onStorage = (event: StorageEvent) => {
      if (event.key !== REFRESH_TOKEN_STORAGE_KEY || event.newValue !== null) return
      if (useAuthStore.getState().status === 'authenticated') notifySessionEnded('logout')
    }
    window.addEventListener('storage', onStorage)
    return () => window.removeEventListener('storage', onStorage)
  }, [])

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        {/* Opted into the v7 behaviours now so the upgrade is not a behaviour change. */}
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <AppRoutes />
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}
